
import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, MessageCircle, MessageSquare } from "lucide-react";

const MobileLinksSection = ({ onClose }: { onClose: () => void }) => {
  return (
    <>
      <div>
        <Link
          to="/consultations"
          className="flex items-center py-3 border-b font-medium text-gray-800 hover:text-grandpal-green transition-colors font-lora"
          onClick={onClose}
        >
          <MessageCircle className="h-5 w-5 text-grandpal-green mr-3" />
          <span>Expert Consultations</span>
        </Link>
      </div>

      <div>
        <Link
          to="/guides"
          className="flex items-center py-3 border-b font-medium text-gray-800 hover:text-grandpal-green transition-colors font-lora"
          onClick={onClose}
        >
          <BookOpen className="h-5 w-5 text-grandpal-green mr-3" />
          <span>Guides</span>
        </Link>
      </div>

      <div>
        <Link
          to="/contact"
          className="flex items-center py-3 border-b font-medium text-gray-800 hover:text-grandpal-green transition-colors font-lora"
          onClick={onClose}
        >
          <MessageSquare className="h-5 w-5 text-grandpal-green mr-3" />
          <span>Chat with Support</span>
        </Link>
      </div>
    </>
  );
};

export default MobileLinksSection;
